/* istanbul ignore file - to be imported from @vg-faset/utilities once custom Angular build work is done. */
/*
 *   This positioner drops the tooltip to the center of the bar and offsets it form the bar,
 *   if there is enough room to do so.
 */

import { Chart, Tooltip } from 'chart.js/auto'

// Extend the TooltipPositionerMap type to include the 'half' property
declare module 'chart.js' {
  interface TooltipPositionerMap {
    half: (elements: any[]) => { x: number; y: number }
  }
}

Tooltip.positioners.half = function (elements) {
  let xOffset = 0
  let yOffset = 0

  // If it's not a super short bar, give it a left or right offset based on the position of the tooltip
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (elements[0]._chart.height - elements[0]._view.y > 20) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      elements[0]._chart.width / 2 >
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      elements[0]._view.x + elements[0]._view.width / 2
    ) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      xOffset = 10
    } else {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      xOffset = -10
    }

    // If it's a tall bar, vertically center tooltip
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (elements[0]._chart.height - elements[0]._view.y > 50) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      yOffset = (elements[0]._chart.height - elements[0]._view.y) / 2
    }
  }

  return {
    x: elements[0]._view.x + xOffset,
    y: elements[0]._view.y + yOffset,
  }
}

export default Chart
